import { handleHttpResponse } from "../../utils/http_response_utils";

export const getMongoTaskData = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-auto4client-task-data", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response)
};
